import { Color, Vec2 } from 'kaplay';
import { Colors } from '../constants/colors';
import { Tags } from '../constants/tags';
import { k } from '../main';

export function addPlayerCircle({ color, pos }: { pos: Vec2; color: Color }) {
  const MOVE_SPEED = 5;
  const playerCircle = add([k.pos(pos), circle(32), area(), body(), Tags.PLAYER]);

  playerCircle.onDraw(() => {
    drawCircle({
      color: rgb(...(Colors.BLACK as [number, number, number])),
      radius: 32,
    });
    drawCircle({
      color,
      radius: 30,
    });
  });

  // the camera follows the player as they move around the map
  playerCircle.onUpdate(() => {
    // TODO: prevent the camera from following when close to map boundary
    setCamPos(playerCircle.pos);
  });

  playerCircle.onKeyDown((key) => {
    if (key === 'left') {
      playerCircle.moveBy(-MOVE_SPEED, 0);
    } else if (key === 'right') {
      playerCircle.moveBy(MOVE_SPEED, 0);
    } else if (key === 'up') {
      playerCircle.moveBy(0, -MOVE_SPEED);
    } else if (key === 'down') {
      playerCircle.moveBy(0, MOVE_SPEED);
    }
  });

  return playerCircle;
}
